export const roleTable = ['client', 'ops', 'admin', 'exploitation', undefined];
export const typeTable = ['paris', 'medical', 'service', undefined];
export const typeTable_2 = ['paris', 'medical', 'service'];
export const expeditionTable = ['import', 'export', 'courses-a-courses', 'course']
export const stateEXpedition = ['en-cours', 'livre', 'a-archivee', 'facturee', 'annulee']
